import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@core/guards/auth-guard';
import { AppCustomPreloader } from '@core/services/custom-preloader';



const routes: Routes = [
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(o => o.AccountModule)
  },
  {
    path: 'authorisation',
    loadChildren: () => import('./authorisation/authorisation.module').then(o => o.AuthorisationModule),
  },
  {
    path: '',
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./ats/ats.module').then(o => o.ATSModule),
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false,
     preloadingStrategy: AppCustomPreloader,
      relativeLinkResolution: 'corrected' ,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'disabled'
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
